import { SlotGameType1_2 } from "../SlotGameType1_2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { FontResource } from "../../ResourceManager/FontResource";
import { SlideFactory } from "../Slider/SecondScreenHelp"
import { SetStyles } from "../../MyHelpers";
// namespace SlotGames2 {
	export class EternalFortuneFillingPot2 extends SlotGameType1_2 {
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

		protected slideFactory: SlideFactory = new EternalFortuneFillingPotSecondScreenHelpFactory();

		protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void {
			super.PaytableLoaded(resourceManager);
		}

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/CuteJellyfish.ttf",this.resid.ScopedResourceName(["SpinAndHold2-font","BigSymbolFreegames2-font"])));
		// }
	}

	class EternalFortuneFillingPotSecondScreenHelpFactory extends SlideFactory {
		public override CreateStyle(): Partial<CSSStyleDeclaration> {
			let style: Partial<CSSStyleDeclaration> =
			{
				color: "White"
			};
			return style;
		}
	}
// }
